// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-dceef70e] input::-webkit-outer-spin-button,[data-v-dceef70e] input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}", ""]);
// Exports
module.exports = exports;
